import { useUserContext } from '../contexts/UserContext'
import t from '../../tools/t'
import { Column } from '../common/pure/FlexContainer'
import Heading from '../common/pure/Heading'
import { NavigationTextLink } from './NavigationLink'

export default function AdminMenu() {
    const { me } = useUserContext()
    if (!me?.isAdmin) return

    return (
        <Column wide gap={0.25} className="sub-menu">
            <Heading size={3}>{t('common_admin')}</Heading>
            <NavigationTextLink
                icon="address-book"
                text={t('manage_organizations')}
                to="/organizations"
            />
        </Column>
    )
}
